import React from 'react';
import {produce} from 'immer';
import {ChartQuery} from 'entities/chart';
import {SearchType} from 'entities/search';
import {serialize} from '../utils/helpers';
import useGlobalFiltersCombined from '../filters/useGlobalFiltersCombined';
import mergeLocalAndGlobalFilters from '../filters/mergeLocalAndGlobalFilters';
import Icon from '@/components/icons/Icon';
import {Tooltip} from '@/components/tooltips';
import i18n from 'i18n';

interface Props {
    chartQuery: ChartQuery;
}

const StoryboardCellSearchButton = React.memo<Props>((
    {
        chartQuery,
    },
) => {
    const [globalAllFields, globalAdditionalFilters] = useGlobalFiltersCombined();

    const [finalAllFields, finalAdditionalFilters] = mergeLocalAndGlobalFilters(
        chartQuery.all_fields,
        chartQuery.additionalFilters,
        globalAllFields,
        globalAdditionalFilters,
    );

    const viewTypeQuery: SearchType = SearchType.Default;

    const finalChartQuery = produce(chartQuery, (draft) => {
        draft.all_fields = finalAllFields;
        draft.additionalFilters = finalAdditionalFilters;
        // @ts-ignore
        draft.view_type_query = viewTypeQuery;
    });

    const buttonStyle = {
        fontSize: '14px',
        height: '38px',
        padding: '4px 6px',
        minWidth: '38px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };

    return (
        <Tooltip content={i18n.t('jt_search_results.text')} placement="top">
            <a
                className="btn app-button btn-outline-info btn-sm"
                href={`${window.URLS.searchView}?${serialize(finalChartQuery)}`}
                target="_blank"
                rel="noopener noreferrer"
                style={buttonStyle}
            >
                <Icon name="mdi-magnify" size="sm" />
            </a>
        </Tooltip>
    );
});

export default StoryboardCellSearchButton;
